import React from "react";
import "./SwitchButton.css"

class MySwitchButton extends React.Component {
    constructor(props) {
        super(props);

        this.state ={
            currentClass : "my-switch-button-outline-success",
            initialClass : "my-switch-button-outline-success",
            selectedClass: "my-switch-button-success",

            currentText : this.props.initialText? this.props.initialText :"Toggle On",
            initialText : this.props.initialText? this.props.initialText :"Toggle On",
            selectedText: this.props.selectedText? this.props.selectedText :"Toggle Off",
            maxLength: 0
        }
        window.$mm_setShowSelectedButtonToggleState = false
    }

    setMaxLength(){
        const initLen = this.state.initialText.length
        const selLen = this.state.selectedText.length
        const max = (initLen > selLen? initLen : selLen) * 12
        this.setState({
            maxLength: max
        })
    }

    async turnOff(){
        await this.setState({
            currentText: this.state.initialText
        })
        await this.setState({
            currentClass: this.state.initialClass
        })
    }

    componentDidMount() {
        if (typeof this.props.turnOff === "function"  ){
            this.props.turnOff(() => this.turnOff())
        }

        this.setMaxLength();
    }

    toggle() {
        this.toggleClass();
        this.toggleText();
    }

    toggleClass() {
        if (this.state.initialClass === this.state.currentClass){
            this.setState({
                currentClass: this.state.selectedClass
            })
        } else {
            this.setState({
                currentClass: this.state.initialClass
            })
        }
    }

    toggleText() {
        if (this.state.initialText === this.state.currentText){
            this.setState({
                currentText: this.state.selectedText
            })
        } else {
            this.setState({
                currentText: this.state.initialText
            })
        }
    }

    render() {
        return (
            <div
                style={{
                    display: "flex",
                    width: this.state.maxLength,
                    alignContent:"center",
                    justifyContent:"center",
                    alignItem:"center",
                    justifyItem:"center",
                }}
            >
                <button
                    className={"my-switch-button " + this.state.currentClass}
                    type="button"

                    onClick={(e) => {
                        typeof this.props.onToggleState === "function" ? this.props.onToggleState(
                            this.state.selectedClass === this.state.currentClass
                        ): void 0;
                        this.toggle();
                        typeof this.props.onClick === "function"? this.props.onClick(e) : void 0;
                    }}
                >
                    {this.state.currentText}
                </button>
            </div>
        );
    }
}

export default MySwitchButton;
